module.exports = __webpack_public_path__ + "img/shine1.2676080b.png";